import {
  CREATE_PLACE,
  CREATE_PLACE_FAILED,
  CREATE_PLACE_SUCCESS,
  DELETE_PLACE,
  DELETE_PLACE_FAILED,
  DELETE_PLACE_SUCCESS,
  GET_COMPLETED_SURVEYS,
  GET_COMPLETED_SURVEYS_FAILED,
  GET_COMPLETED_SURVEYS_SUCCESS,
  GET_PLACES,
  GET_PLACES_FAILED,
  GET_PLACES_SUCCESS,
  GET_PLACE_DATA,
  GET_PLACE_DATA_FAILED,
  GET_PLACE_DATA_SUCCESS,
  HIDE_CONFIRM_DELETE_MODAL,
  OPEN_CONFIRM_DELETE_MODAL,
  RESET_SURVEYS_DATA,
  RESET_PLACE_DATA,
  UPDATE_PLACE,
  UPDATE_PLACE_FAILED,
  UPDATE_PLACE_SUCCESS,
  GET_PLACE_SURVEY_REPLIES,
  GET_PLACE_SURVEY_REPLIES_FAILED,
  GET_PLACE_SURVEY_REPLIES_SUCCESS,
  SHOW_BULK_UPLOAD_MODAL,
  HIDE_BULK_UPLOAD_MODAL,
  SET_BULK_UPLOAD_FLAG,
  GET_PLACES_WITH_CHAPTERS,
  GET_CHAPTERS,
  GET_PLACES_WITH_CHAPTERS_FAILED,
  GET_CHAPTERS_FAILED,
  GET_PLACES_WITH_CHAPTERS_SUCCESS,
  GET_CHAPTERS_SUCCESS,
  GET_PLACES_REPORTS,
  GET_PLACES_REPORTS_FAILED,
  GET_PLACES_REPORTS_SUCCESS,
  GET_PLACES_SUMMARY_REPORTS,
  GET_PLACES_SUMMARY_REPORTS_FAILED,
  GET_PLACES_SUMMARY_REPORTS_SUCCESS,
} from "./actionTypes"

const initialState = {
  loading: false,
  error: "",
  places: null,
  categories: [],
  placeData: null,
  confirmDeleteModalIsOpen: false,
  completedSurveys: [],
  placeSurveyReplies: null,
  bulkUploadModalIsOpen: false,
  bulkUploadFlag: false,
  placesWithChapters: [],
  chapters: [],
  placesReports: null,
  placesSummaryReports: null,
}

const PlacesList = (state = initialState, action) => {
  switch (action.type) {
    case GET_PLACES:
    case GET_PLACE_DATA:
    case CREATE_PLACE:
    case UPDATE_PLACE:
    case DELETE_PLACE:
    case GET_COMPLETED_SURVEYS:
    case GET_PLACE_SURVEY_REPLIES:
    case GET_PLACES_WITH_CHAPTERS:
    case GET_CHAPTERS:
    case GET_PLACES_REPORTS:
    case GET_PLACES_SUMMARY_REPORTS:
      return {
        ...state,
        loading: true,
      }
    case GET_PLACES_SUCCESS:
      return {
        ...state,
        places: action.payload,
        loading: false,
      }
    case GET_PLACES_FAILED:
    case GET_PLACE_DATA_FAILED:
    case CREATE_PLACE_FAILED:
    case UPDATE_PLACE_FAILED:
    case DELETE_PLACE_FAILED:
    case GET_COMPLETED_SURVEYS_FAILED:
    case GET_PLACE_SURVEY_REPLIES_FAILED:
    case GET_PLACES_WITH_CHAPTERS_FAILED:
    case GET_CHAPTERS_FAILED:
    case GET_PLACES_REPORTS_FAILED:
    case GET_PLACES_SUMMARY_REPORTS_FAILED:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }
    case GET_PLACE_DATA_SUCCESS:
      return {
        ...state,
        placeData: action.payload,
        loading: false,
      }
    case RESET_PLACE_DATA:
      return {
        ...state,
        placeData: null,
      }
    case CREATE_PLACE_SUCCESS:
    case UPDATE_PLACE_SUCCESS:
    case DELETE_PLACE_SUCCESS:
      return {
        ...state,
        loading: false,
      }
    case OPEN_CONFIRM_DELETE_MODAL:
      return {
        ...state,
        confirmDeleteModalIsOpen: true,
      }
    case HIDE_CONFIRM_DELETE_MODAL:
      return {
        ...state,
        confirmDeleteModalIsOpen: false,
      }
    case GET_COMPLETED_SURVEYS_SUCCESS:
      return {
        ...state,
        completedSurveys: action.payload,
        loading: false,
      }
    case RESET_SURVEYS_DATA:
      return {
        ...state,
        completedSurveys: [],
        placeSurveyReplies: null,
      }
    case GET_PLACE_SURVEY_REPLIES_SUCCESS:
      return {
        ...state,
        placeSurveyReplies: action.payload,
        loading: false,
      }
    case SHOW_BULK_UPLOAD_MODAL:
      return {
        ...state,
        bulkUploadModalIsOpen: true,
      }
    case HIDE_BULK_UPLOAD_MODAL:
      return {
        ...state,
        bulkUploadModalIsOpen: false,
      }
    case SET_BULK_UPLOAD_FLAG:
      return {
        ...state,
        bulkUploadFlag: action.payload,
      }
    case GET_PLACES_WITH_CHAPTERS_SUCCESS:
      return {
        ...state,
        placesWithChapters: action.payload,
        loading: false,
      }
    case GET_CHAPTERS_SUCCESS:
      return {
        ...state,
        chapters: action.payload,
        loading: false,
      }
    case GET_PLACES_REPORTS_SUCCESS:
      return {
        ...state,
        placesReports: action.payload,
      }
    case GET_PLACES_SUMMARY_REPORTS_SUCCESS:
      return {
        ...state,
        placesSummaryReports: action.payload,
      }
    default:
      return state
  }
}

export default PlacesList
